module.exports = __webpack_public_path__ + "img/sakura-background.01a06632.png";